import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/lib/analytics';

/**
 * Invisible tracker: records a pageview on every route change.
 * Admin pages are excluded so internal usage doesn't skew stats.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    trackPageview(location.pathname);
  }, [location.pathname]);
  return null;
}
